import React from 'react';
import { Link } from 'react-router-dom';
import ResearchCard from '../ResearchCard';
import { RESEARCH_AREAS } from '../../data/research';

export default function ResearchHighlights() {
  const featured = RESEARCH_AREAS.slice(0, 3);

  return (
    <section className="py-24 md:py-32 px-6 background-grid">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-gray-500">
              What We Study
            </span>
            <h2 className="text-4xl md:text-5xl font-light mt-4 mb-6">
              Research Highlights
            </h2>
            <div className="w-24 h-px bg-gray-900" />
          </div>
          <Link to="/research" className="text-gray-700 hover:text-gray-900 text-sm uppercase tracking-widest">
            See all research →
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {featured.map((r, i) => (
            <ResearchCard key={r.title} title={r.title} description={r.description} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}
